import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import { decodeVersionString } from '@/utils/versionConverter'

export function WorkflowVersionCell () {
  return class extends GridCell {
    render () {
      return <td>{decodeVersionString(this.props.dataItem[this.props.field])}</td>
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/BsrsGrid.WorkflowVersionCell.js